module.exports = __webpack_public_path__ + "static/media/whitePen.25b47bba.svg";